// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import gpuCardMng from './metaData/gpuCard'
export default {
  state: gpuCardMng,
  actions
}
